// extracted by mini-css-extract-plugin
module.exports =  {"root":"BzF2bQbm8ZJEGcXOu6D4","mediaCreditBalance":"LKVpje7DDxrjtp3Cr8no","marginBuster":"qlT7JIo637UwF_9nkdPW","bigNumber":"liHy1rqkJNfhSNWS1HgA"};